import { render } from "./ProductItem.vue?vue&type=template&id=961bea92&scoped=true"
import script from "./ProductItem.vue?vue&type=script&lang=js"
export * from "./ProductItem.vue?vue&type=script&lang=js"

import "./ProductItem.vue?vue&type=style&index=0&id=961bea92&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-961bea92"

export default script